import type { Patient, Reference } from '@medplum/fhirtypes'
import type { GoalCarePlan } from '@seen/core/models/care-plans/GoalCarePlan'
import { Diagnosis } from '@seen/core/models/conditions/Diagnosis'
import type { JSX } from 'react'
import { ConditionDisplay } from '#src/components/condition/ConditionDisplay.tsx'
import { Loader } from '#src/components/core/Loader.tsx'
import { useSearch } from '#src/hooks/useSearch.ts'

export function ConditionList(props: {
  patient: Reference<Patient>
  goalCarePlans: GoalCarePlan[]
}): JSX.Element {
  const { goalCarePlans } = props
  const conditionRefs = goalCarePlans.flatMap(
    (goalCarePlan) => goalCarePlan.conditions
  )
  const conditionsQuery = useSearch(
    Diagnosis,
    {
      _id: conditionRefs,
    },
    { query: { enabled: !!conditionRefs.length } }
  )

  if (conditionsQuery.isLoading) {
    return <Loader />
  }

  return (
    <div className="flex flex-col gap-2">
      {Diagnosis.sortForDisplay(conditionsQuery.data ?? []).map((condition) => (
        <ConditionDisplay key={condition.id} condition={condition} />
      ))}
    </div>
  )
}
